import {
  StyledTable,
  StyledRow,
  StyledAddImage,
  StyledTouchCharter,
  StyledButtonImage,
  StyledFlexTheContainer,
} from "../../components/styles/containers/Containers";
import Error from "../../components/errors/Error";
import PreviewImage from "./PreviewImage";
import { useRef, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { CgMathPlus as OutlinePlus } from "react-icons/cg";

const Grid = ({ images, onImagesAdd, onImageRemove }) => {
  const inputRef = useRef(null);
  const onDrop = useCallback(
    (acceptedFiles) => {
      onImagesAdd(acceptedFiles);
    },
    [onImagesAdd]
  );
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <StyledTouchCharter
      {...getRootProps()}
      tabIndex={0}
      style={{ outline: "none" }}
    >
      <StyledTable>
        <StyledFlexTheContainer>
          <StyledRow>
            <StyledAddImage
              title="Lägg till bild"
              role="button"
              aria-roledescription="Klicka för att lägga till fler bilder"
            >
              <>
                <input
                  name="images"
                  type="file"
                  id="upload-button"
                  multiple
                  onChange={(e) => {
                    onImagesAdd(Array.from(e.target.files));
                  }}
                  ref={inputRef}
                  style={{ display: "none" }}
                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                  {...getInputProps({ ref: inputRef })}
                />
                <StyledButtonImage
                  onClick={(e) => {
                    e.stopPropagation();
                    if (inputRef.current) inputRef.current.click();
                  }}
                >
                  <OutlinePlus
                    alt=""
                    aria-hidden="true"
                    size="2.4rem"
                    style={{
                      color: "#046a38",
                    }}
                  />
                </StyledButtonImage>
              </>
            </StyledAddImage>
            {images
              .map((img) => (
                <PreviewImage
                  tabindex="0"
                  key={img.id}
                  image={img}
                  onImageRemove={onImageRemove}
                />
              ))
              .reverse()}
          </StyledRow>
        </StyledFlexTheContainer>
      </StyledTable>
    </StyledTouchCharter>
  );
};

export default Grid;
